import { render, staticRenderFns } from "./ArticleListPage.vue?vue&type=template&id=4764e1c7&scoped=true"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleListPage.vue?vue&type=style&index=0&id=4764e1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764e1c7",
  null
  
)

export default component.exports